// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (max-width: 599px) {
  .mat-form-field {
    width: 100%;
  }
}
.white ::placeholder {
  color: #fff !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/search/search.component.scss"],"names":[],"mappings":"AAAA;EACI;IACI,WAAA;EACN;AACF;AAEA;EACI,sBAAA;AAAJ","sourcesContent":["@media only screen and (max-width: 599px) {\n    .mat-form-field {\n        width: 100%;\n    }\n}\n\n.white ::placeholder {\n    color: #fff !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
